var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title roboto-thin"},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("default")],2),(_vm.$slots['subtitle'])?_c('h2',{staticClass:"subtitle-1"},[_vm._t("subtitle")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }